var getVariableFn = null;
export var getCSSVar = function getCSSVar() {
  if (!getVariableFn) {
    if (isCssVarsSupported()) {
      getVariableFn = getCssVariableFromDocumentBody;
    } else {
      getVariableFn = getCssVariable;
    }
  }
  return getVariableFn;
};
var parseCssVariable = function parseCssVariable(cssVarValue, rgbName, rgbModifier) {
  if (cssVarValue.includes('rgb') || cssVarValue.includes('rgba')) {
    if (cssVarValue.includes(',')) {
      var nestedCssVar = cssVarValue.match(/(.*?)\(.*?\((.*?)\),(.*?)\)/); // extract value from "rgba(var(--nested-css-var), 0.75)"
      var _rgbModifier = nestedCssVar[3];
      var _rgbName = nestedCssVar[1];
      return getCssVariable(nestedCssVar[2], _rgbName, _rgbModifier);
    } else {
      var _nestedCssVar = cssVarValue.match(/(.*?)\(.*?\((.*?)\)\)/); // extract value from "rgb(var(--nested-css-var))"
      var _rgbName2 = _nestedCssVar[1];
      return getCssVariable(_nestedCssVar[2], _rgbName2);
    }
  } else if (cssVarValue.includes('var')) {
    var _nestedCssVar2 = cssVarValue.match(/\((.*?)\)/)[1]; // extract value from "var(--nested-css-var)"
    if (rgbName || rgbModifier) {
      return getCssVariable(_nestedCssVar2, rgbName, rgbModifier);
    }
    return getCssVariable(_nestedCssVar2);
  }
};
export var getCssVariable = function getCssVariable(value) {
  var rgbName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var rgbModifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var _window = window,
    cssVariables = _window.cssVariables;
  var supportedVars = ['rgb', 'rgba', 'var'];
  var cssVariable = cssVariables[value];
  var isSupportedVariable = supportedVars.some(function (item) {
    return cssVariable.indexOf(item) !== -1;
  });
  if (isSupportedVariable) {
    return parseCssVariable(cssVariable, rgbName, rgbModifier);
  }
  if (rgbName && rgbModifier) {
    return rgbName + '(' + cssVariable + ',' + rgbModifier + ')';
  } else if (rgbName) {
    return rgbName + '(' + cssVariable + ')';
  } else {
    return cssVariable;
  }
};
export var isCssVarsSupported = function isCssVarsSupported() {
  return window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)');
};
export var getCssVariableFromDocumentBody = function getCssVariableFromDocumentBody(value) {
  return getComputedStyle(document.body).getPropertyValue(value).trim();
};